/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SubCampaign
 */
export interface SubCampaign {
  /**
   *
   * @type {number}
   * @memberof SubCampaign
   */
  _package: number;
  /**
   *
   * @type {number}
   * @memberof SubCampaign
   */
  grps: number;
  /**
   *
   * @type {number}
   * @memberof SubCampaign
   */
  budget?: number | null;
}

export function SubCampaignFromJSON(json: any): SubCampaign {
  return SubCampaignFromJSONTyped(json, false);
}

export function SubCampaignFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SubCampaign {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    _package: json["package"],
    grps: json["grps"],
    budget: !exists(json, "budget") ? undefined : json["budget"],
  };
}

export function SubCampaignToJSON(value?: SubCampaign | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    package: value._package,
    grps: value.grps,
    budget: value.budget,
  };
}
